import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, retry, switchMap, timer } from 'rxjs';
import { Store } from '@ngxs/store';
import { DownloadsActions, OnderwijslocatiesActions } from '@store/actions';
import { LoadToetsen } from '@store/actions/toetsen.actions';
import { LoadSettings } from '@store/actions/settings.actions';

const HOUR_IN_MS = 3_600_000;
const INITIAL_DELAY_DURATION = 100;

@Injectable({ providedIn: 'root' })
export class StateService {
  private readonly destroyRef = inject(DestroyRef);
  constructor(private readonly store: Store) {}

  public initState() {
    this.startTimer('toetsen', () => this.store.dispatch(new LoadToetsen()), HOUR_IN_MS);
    this.dispatchOnce('settings', () => this.store.dispatch(new LoadSettings()));
    this.startTimer('downloads', () => this.store.dispatch(new DownloadsActions.LoadDownloads()), HOUR_IN_MS);
    this.startTimer(
      'onderwijslocaties',
      () => this.store.dispatch(new OnderwijslocatiesActions.LoadOnderwijslocaties()),
      HOUR_IN_MS,
    );
  }

  private dispatchOnce(type: string, storeAction: () => Observable<unknown>) {
    storeAction()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        retry({
          delay: (error, retryCount) => {
             
            console.error(
              `error detected while dispatching action for: ${type}. Refresh in ${
                Math.pow(2, retryCount) * INITIAL_DELAY_DURATION
              }ms. Error:`,
              error,
            );
            return timer(Math.pow(2, retryCount) * INITIAL_DELAY_DURATION);
          },
          resetOnSuccess: true,
        }),
      )
      .subscribe();
  }

  private startTimer(type: string, storeAction: () => Observable<unknown>, intervalDuration: number) {
    timer(0, intervalDuration)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        switchMap(() => storeAction()),
        retry({
          delay: (error, retryCount) => {
             
            console.error(
              `error detected while dispatching action for: ${type}. Refresh in ${
                Math.pow(2, retryCount) * INITIAL_DELAY_DURATION
              }ms. Error:`,
              error,
            );
            return timer(Math.pow(2, retryCount) * INITIAL_DELAY_DURATION);
          },
          resetOnSuccess: true,
        }),
      )
      .subscribe();
  }

}
